export default
    {
        detallesEntrega: "/movimientos/detallesInternamiento2",
        createDetalles: "/movimientos/createDetalles2",
        actualizaMotivo: "/internamientos/actualizaMotivo",
        list: "/internamientos/listV2",
    }
